import React, { FC } from "react";
import closeIcon from "../../../../src/icons/modal_close.svg";
import styles from "./Modal.module.scss";
import Button from "components/Button/Button";

interface ModalProps {
  onClose: () => void;
}

const Modal: FC<ModalProps> = ({ onClose }) => (
  <>
    <div className={styles.overlay} onClick={onClose}></div> {/* Оверлей */}
    <div className={styles.modal}>
      <button onClick={onClose} className={styles.modalCloseButton}>
        <img src={closeIcon} alt="Закрыть" />
      </button>
      <h2 className={styles.modalTitle}>Заявление успешно отправлено</h2>
      <p>Менеджер скоро свяжется с Вами</p>
      <Button
        className={styles.submitBtn}
        type="primary"
        htmlType="submit"
        onClick={onClose}
      >
        OK
      </Button>
    </div>
  </>
);

export default Modal;
